module.exports = __webpack_public_path__ + "static/media/clouds.6edfb7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clouds.png
// module id = 333
// module chunks = 3